<template>
	<div v-if="showDialog" class="data-policy-overlay">
		<div class="data-policy-dialog">
			<div class="data-use-policy">
				<h2>Welcome to Grub Vision</h2>
				<p>
					Before you start, we want to be transparent about how we handle your
					data.
				</p>
				<ul>
					<li>
						We collect your location to find restaurant locations and detect
						when you're at a restaurant.
					</li>
					<li>
						We may ask for access to your camera to identify food items using
						artificial intelligence.
					</li>
					<li>
						We collect health information like weight and blood sugar levels
						that you provide to us, which we process using AI to provide
						personalized recommendations.
					</li>
					<li>We also collect usage and device data to improve our app.</li>
				</ul>
				<p>
					We share some data with third-party services for functionality, such
					as restaurant location APIs, image recognition services, and error
					reporting tools.
				</p>
				<p>
					Please read our full
					<router-link to="/privacy-policy" @click="temporarilyHideDialog"
						>Privacy Policy</router-link
					>
					and
					<router-link to="/terms" @click="temporarilyHideDialog"
						>Terms of Use</router-link
					>
					for more details on our data practices, your rights, and how to
					contact us.
				</p>
				<p>
					By clicking 'Accept', you agree to our Privacy Policy and Terms of
					Use.
				</p>
				<button @click="acceptPolicy" class="accept-button">Accept</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, watch } from "vue"
	import { useDataPolicyStore } from "../stores/data-policy"
	import { useRoute } from "vue-router"

	const dataPolicyStore = useDataPolicyStore()
	const route = useRoute()
	const showDialog = ref(false)
	// const temporarilyHidden = ref(false)

	// Function to handle policy acceptance
	const acceptPolicy = async () => {
		await dataPolicyStore.setAgreedToDataPolicy(true)
		showDialog.value = false
	}

	// Function to check if we're on a policy page (privacy policy or terms)
	const ignorePath = (path) => {
		return path === "/privacy-policy" || path === "/terms" || path === "/"
	}

	// Watch for route changes to show the dialog again if needed
	watch(
		() => route.path,
		async (newPath) => {
			// console.log(newPath)
			await dataPolicyStore.loadDataPolicyAgreement()
			if (!dataPolicyStore.hasAgreed() && !ignorePath(newPath)) {
				showDialog.value = true
			} else {
				showDialog.value = false
			}
		},
		{ immediate: true }
	)
</script>

<style lang="less" scoped>
	.data-policy-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}

	.data-policy-dialog {
		max-width: 600px;
		width: 90%;
		max-height: 90vh;
		overflow-y: auto;
		//background: #fff;
		background-color: black; //#535160;
		border-radius: 8px;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
	}

	.data-use-policy {
		padding: 20px;
		text-align: left;

		h2 {
			color: #ff6400 !important;
			font-size: 24px;
			margin-bottom: 15px;
		}

		p {
			color: #ff6400;
			font-size: 16px;
			margin-bottom: 10px;
		}

		ul {
			list-style-type: none;
			padding-left: 0;
			margin-bottom: 15px;
		}

		li {
			color: #ff6400;
			padding-left: 1em;
			text-indent: -1em;
			margin-bottom: 8px;

			&:before {
				content: "• ";
			}
		}

		a {
			color: #ff6400;
			text-decoration: underline;
		}

		.accept-button {
			background-color: #ff6400;
			color: white;
			border: none;
			padding: 10px 20px;
			border-radius: 5px;
			font-size: 16px;
			cursor: pointer;
			transition: background-color 0.3s;
			margin-top: 10px;

			&:hover {
				background-color: #e55a00;
			}
		}
	}
</style>
